class PdpThumbNails extends HTMLElement {
  thumbnailNodes;
  mainImageNodes;

  activeThumbnailClasses = "border-orange p-2"; // This value should match what is being used in main-product.liquid

  constructor() {
    super();
    this.thumbnailNodes = this.querySelectorAll("li");

    this.thumbnailNodes.forEach((node) => {
      node.addEventListener("click", () => {
        this.toggleThumbnailClass(node.dataset.mediaId);
        this.setMainImageByMediaId(node.dataset.mediaId);
      });
    });
  }

  showThumbnailsByAltText(altText) {
    this.thumbnailNodes.forEach((node) => {
      if (node.dataset.alt === altText) {
        node.classList.remove("hidden");
      } else {
        node.classList.add("hidden");
      }
    });
  }

  toggleThumbnailClass(mediaId) {
    const activeThumbnailClasses = this.activeThumbnailClasses.split(" ");

    this.thumbnailNodes.forEach((node) => {
      if (node.dataset.mediaId.includes(mediaId)) {
        node.classList.remove("border-transparent");
        node.classList.add(...activeThumbnailClasses);
      } else {
        node.classList.add("border-transparent");
        node.classList.remove(...activeThumbnailClasses);
      }
    });
  }

  setMainImageByMediaId(mediaId) {
    let mainImageNode;
    const mainImageNodes = this.getMainImageNodes();

    mainImageNodes.forEach((node) => {
      if (node.dataset.mediaId.includes(mediaId)) {
        node.classList.remove("hidden");
        node.classList.add("block");
        mainImageNode = node;
      } else {
        node.classList.remove("block");
        node.classList.add("hidden");
      }
    });

    return mainImageNode;
  }

  getMainImageNodes() {
    this.mainImageNodes =
      this.mainImageNodes || document.querySelectorAll("[data-main-image]");
    return this.mainImageNodes;
  }
}

customElements.define("pdp-thumbnails", PdpThumbNails);
